import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ChatListPage } from './chat-list';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [
    ChatListPage,
  ],
  imports: [
		PipesModule,
    IonicPageModule.forChild(ChatListPage),
  ],
})
export class ChatListPageModule {}



// WEBPACK FOOTER //
// ./src/pages/chat-list/chat-list.module.ts